import type * as React from 'react';

import { Button, LoadingIndicator, PageSplitTitle } from '@gitbook/spine-react';
import { useHeadTitle } from '@gitbook/util-react-head';

import { useHideSplashscreen } from '../../Components';
import { LoginScreenLayout } from './LoginScreenLayout';

/**
 * Step to redirect to desktop application when authenticating for desktop.
 */
export function StepRedirectToContinueUrl(): React.ReactElement {
    useHideSplashscreen(0);
    useHeadTitle('Redirecting…');

    return (
        <LoginScreenLayout>
            <PageSplitTitle>Redirecting…</PageSplitTitle>
            <Button
                leadingIcon={LoadingIndicator}
                kind="secondary"
                disabled
                label="Continue"
                size="large"
            />
        </LoginScreenLayout>
    );
}
